export enum MetadataEntryType {
  StimulusLoad = 'Stimulus load',
  StimulusUnload = 'Stimulus unload',
  QuestionLoad = 'Question load',
  QuestionUnload = 'Question unload',
}
